import { Expose, Type } from 'class-transformer';
import { BasicData } from '../basic/BasicData';

export class UnitType {
    @Expose()
    id: number = 0;

    @Expose()
    type: string = '';

    @Expose()
    name: string = '';
}

export class MilitaryUnit extends BasicData {
    static readonly ModelFeatureAttribute = {
        CLASS_NAME: 'MilitaryUnit',
    };

    @Expose()
    @Type(() => Number)
    id: number = 0;

    @Expose()
    name: string = '';

    @Expose()
    @Type(() => UnitType)
    type: UnitType | null = null;

    @Expose()
    @Type(() => Number)
    parentUnitId: number | null = null;

    @Expose()
    archived: boolean = false;

    @Expose()
    @Type(() => MilitaryUnit)
    children: MilitaryUnit[] = [];

    @Expose()
    @Type(() => Object)
    polygon: GeoJSON.Polygon | null = null;

    @Expose()
    @Type(() => Array)
    center: [number, number] | null = null; // [lat, lng] centroid of polygon
}
